import { CheckCircle, Eye, Link } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface FeatureValueProps {
  value: any;
}

const FeatureValue = ({ value }: FeatureValueProps) => {
  // Boolean true - full access checkmark
  if (value === true) {
    return <CheckCircle className="w-5 h-5 text-primary mx-auto" />;
  }
  
  // Boolean false - dash for not available
  if (value === false) {
    return <span className="text-muted-foreground text-center">, </span>;
  }
  
  // String emoji indicators - render as matching Lucide icons
  if (value === "✔") {
    return <CheckCircle className="w-5 h-5 text-primary mx-auto" />;
  }
  if (value === "👁") {
    return <Eye className="w-5 h-5 text-amber-600 mx-auto" />;
  }
  if (value === "🔗") {
    return <Link className="w-5 h-5 text-blue-500 mx-auto" />;
  }
  
  // Other string values (like "5 Img", "Unlimited") - render in badge
  return (
    <div className="text-center">
      <Badge variant="secondary" className="text-xs px-2 py-1">
        {value}
      </Badge>
    </div>
  );
};

export default FeatureValue;